export default __webpack_public_path__ + "static/media/Eurojackpot.e2e3c724.png";